export const BLOCKED_COUNTRIES = [
    'NG', // Nigeria
    'BD', // Bangladesh
    'IN', // India
    'PK', // Pakistan
    'LK' // Sri Lanka
];

export const MINIMUM_VALIDATED_LANGUAGE_LEVEL = 2;

export const BLOCKED_COUNTRIES_SET = new Set(BLOCKED_COUNTRIES);
